import React from 'react';
import Icon from '../../../components/AppIcon';

const KPICard = ({ title, value, change, changeType, icon, iconColor, trend }) => {
  const isPositive = changeType === 'positive';
  const isNegative = changeType === 'negative';
  const isNeutral = changeType === 'neutral';

  return (
    <div className="bg-card rounded-lg shadow-sm border border-border p-4 md:p-6 transition-smooth hover-lift">
      <div className="flex items-start justify-between mb-3 md:mb-4">
        <div className="flex-1 min-w-0">
          <p className="caption text-muted-foreground mb-1">{title}</p>
          <h3 className="font-heading font-semibold text-2xl md:text-3xl lg:text-4xl text-foreground">
            {value}
          </h3>
        </div>
        <div 
          className={`
            w-10 h-10 md:w-12 md:h-12 rounded-md flex items-center justify-center flex-shrink-0
            ${iconColor === 'primary' ? 'bg-primary/10' : ''}
            ${iconColor === 'secondary' ? 'bg-secondary/10' : ''}
            ${iconColor === 'accent' ? 'bg-accent/10' : ''}
            ${iconColor === 'success' ? 'bg-success/10' : ''}
            ${iconColor === 'error' ? 'bg-error/10' : ''}
          `}
        >
          <Icon name={icon} size={20} color={`var(--color-${iconColor})`} />
        </div>
      </div>
      
      <div className="flex items-center gap-2">
        <div className={`
          flex items-center gap-1 px-2 py-1 rounded-md text-xs font-medium
          ${isPositive ? 'bg-success/10 text-success' : ''}
          ${isNegative ? 'bg-error/10 text-error' : ''}
          ${isNeutral ? 'bg-muted text-muted-foreground' : ''}
          ${!isPositive && !isNegative && !isNeutral ? 'bg-muted text-muted-foreground' : ''}
        `}>
          {!isNeutral && (
            <Icon 
              name={isPositive ? 'TrendingUp' : isNegative ? 'TrendingDown' : 'Minus'} 
              size={14} 
            />
          )}
          <span>{change}</span>
        </div>
        <span className="caption text-muted-foreground">{trend}</span>
      </div>
    </div>
  );
};

export default KPICard;
